import { useCallback, useEffect, useMemo, useState } from "react";

export const useOption = (props) => {
  
  const { attribute_id, onSelectionChange, selectedValue, values } = props;

  const initialSelection = useMemo(() => {
    let initialSelection = {};
    const searchValue = selectedValue;
    if (searchValue) {
      initialSelection =
        values.find((value) => value.value_index === searchValue) || {};
    }
    return initialSelection;
  }, [selectedValue, values]);

  const handleSelectionChange = useCallback(
    (selection) => {
      if (onSelectionChange) {
        onSelectionChange(attribute_id, selection);
      }
    },
    [attribute_id, onSelectionChange]
  );

  return {
    handleSelectionChange,
    initialSelection,
  };
};
